/** The pages a family opens from a link we text or email them. */
export const FAMILY_LINK_PAGES = [
  "onboarding",
  "consent",
  "update-insurance",
  "back-to-school",
  "marty-consent",
] as const;

export type FamilyLinkPage = (typeof FAMILY_LINK_PAGES)[number];

/**
 * How long a family link works. Onboarding reminders run for weeks; once a
 * link is older than this, the family signs in instead.
 */
export const FAMILY_LINK_TTL_MS = 30 * 24 * 60 * 60 * 1000;

export const FAMILY_LINK_TOKEN_PURPOSE = "family-link";

/** One cookie per student: a phone may hold links for siblings. */
export const FAMILY_LINK_COOKIE_PREFIX = "marble_family_link_";
